export const locale = {
    lang: 'en',
    data: {
        USER: {
            MENU: {
                CHANGE: 'Change',
                LOGOUT: 'Logout',
                THEME: {
                    LIGHT: 'Light',
                    DARK: 'Dark',
                    AUTO: 'System',
                },
                PLAN_PAYMENTS: 'Plans and payments',
                LOCATION_STATUS: {
                    TRIAL_EXPIRES: 'TRIAL EXPIRES IN {{ days }} DAYS. GET IT NOW!',
                    TRIAL_EXPIRES_ONE_DAY: 'TRIAL EXPIRES IN {{ days }} DAY. GET IT NOW!',
                },
            },
        }
    },
};
